/** Bundled defaults when SPACEY_CONFIG fields are unset for a market. */
export const DEFAULT_SPACEY_LAUNCHER_GREETING = "Hi I'm Spacey, How can I help you today?";

/** First stop of the chat instruction bubble gradient (.initial-message-content). */
export const DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR = '#0069c4';

/** Text colour inside the instruction bubble when unset in admin. */
export const DEFAULT_SPACEY_INSTRUCTION_MESSAGE_TEXT_COLOR = '#ffffff';
